import { useRemoteData } from "./ReactDataGridHooks";

export default useRemoteData;